import React from 'react';
import { useBookingContext } from '../../context/BookingContext';

const ConfirmationSuccess = ({closeCallback}) => {

    const { refetchBooking } = useBookingContext();

    const handleClose = () => {
        closeCallback();
        refetchBooking();
    }

    return (
        <div className="w-96 h-16">
            <div className="text-green-600 flex flex-col items-center">
                <div>
                    Confirmation success
                </div>
                <button className="btn-blue btn-blue-active inline" onClick={handleClose}>Close</button>
            </div>
        </div>
    )
}

export default ConfirmationSuccess;
